module.exports = __webpack_public_path__ + "img/addr-blue.aac06882.png";